import React from 'react';
import WhoWeAre from '../components/WhoWeAre';

export const About = () => {
  return (
    <WhoWeAre />
  )
}
